import { useEffect, useState } from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPostPaginationList, getProjectActiveList } from "../../../../../redux/project/action";
import { useRouteBaseStateContext } from "../../../../../Context/RouteBaseStateContext";
import GetRemainDays from "../../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetRemainDays";
import GetStatus from "../../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetStatus";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import OrderPostPagination from "../../../FindWork/SearchAll/AllPosts/CustomPagination/OrderPostPagination";
import { PAGE_SIZE } from "../../../../../redux/constants";
import GetProjectStatus from "../../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetProjectStatus";

export default function ActiveProjects() {
  const { setMyorderActiveprojectroute } = useRouteBaseStateContext();

  const path = "Assets/scss/myorders.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const [listdata, setListdata] = useState("")
  const [pageNumber, setPageNumber] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(getProjectActiveList(1));
    const data = {
      type: 1,
      index: pageNumber,
      size: PAGE_SIZE,
      status: 2
    }
   if(data){
     dispatch(getPostPaginationList(data)).then((res) => {
      setListdata(res)
    })
   }
  }, [pageNumber]);

  
  return (
    <div className ="order-tabs">
      <div className ="tab-content">
        <div className ="posted-project">
          {Array.isArray(listdata?.response) && (
            <>
              <h4>Project</h4>
              <OrderPostPagination
                totalitemcounts={listdata?.count}
                size={PAGE_SIZE}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
              />
              {/* <ListLoader /> */}
              {listdata?.response?.length == 0 && <PostNotFound title={"No Post Found"} />}
              <div className ="recent-post">
                {listdata?.response.slice(0, 10).map((item, index) => (
                  <div className ="post-back">
                    <div className ="col-md-5 ">
                      <h3>{item?.title}</h3>
                      <GetRemainDays
                        enddate={item?.active_milestone?.ends_on}
                      />
                    </div>
                    <div className ="activity col-md-4">
                      <h6>Active milestone: {item?.active_milestone_count}</h6>
                      <h5>
                        {!item?.active_milestone?.title
                          ? "No Active Milestone"
                          : item?.active_milestone?.title}
                      </h5>
                      <GetProjectStatus status={item?.active_milestone?.status} />
                    </div>
                    <button
                      className ="btn"
                      onClick={() => {
                        navigate(
                          `/${lan}/dashboard/managework/projects/active/${item.id}`,
                        );
                        setMyorderActiveprojectroute("");
                      }}
                    >
                      View details
                      <img
                        src={`${CloudStorage.cloudurl}Assets/Images/homepage/right-arrow-orange.svg`}
                        alt=""
                      />
                    </button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
